import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const managedVoipRoutes = {
  [ERouteMappingKeys.MANAGED_VOIP]: {
    id: "managed-voip",
    path: "/integrations/managed-voip",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/Integrations/ManagedVoIP/ManagedVoIP").then(
          (p) => ({ default: p.ManagedVoIP }),
        ),
      ),
      "international-rates": lazy(() =>
        import(
          "pages/Sections/PhoneSystem/InternationalRates/InternationalRates"
        ).then((p) => ({
          default: p.InternationalRates,
        })),
      ),
    },
  },
};
